<template>
    <div class="common">
        <search-form :formConfig="formConfig" :source="searchData" @handleSearchJsf="handleSearchJsf"
            @handleSearchManager="handleSearchManager" @handleSearchKlf="handleSearchKlf" @search="search">
            <template slot="btns" v-if="tabType == 'review'">
                <a-button @click="showModal(2)" :loading="checkLoad" class="search-btn-item" type="primary"
                    :disabled="!selectedRowKeys.length || !isPromiseGoldcheck">同意</a-button>
                <a-button @click="showModal(3)" :loading="checkLoadCancel" class="search-btn-item btn-blue-line"
                    :disabled="!selectedRowKeys.length || !isPromiseGoldcheck">拒绝</a-button>
            </template>
            <template slot="btns" v-if="tabType=='records'">
            <a-button @click="onExport" class="search-btn-item" type="primary">导出</a-button>
        </template>
        </search-form>
        <div>
            <a-checkbox v-if="status == '1'" v-model="isPromiseGoldcheck"
                style="margin:0 0 16px 0;">已阅读并同意所勾选的《连带责任担保函》</a-checkbox>
        </div>
        <div class="table-common">
            <a-table size="middle" :columns="columns" :data-source="tableData" :pagination="pagination" :loading="loading"
                :row-key="(record, index) => record.id + '_' + record.createTime" @change="handleTableChange" bordered
                :scroll="{ x: '100%' }" :locale="{ emptyText: '暂无数据' }" :row-selection="tableSelect">
                <template slot="guaranteeName" slot-scope="text,record">
                    <span v-if="record.guaranteeName">
                        {{ record.guaranteeName }}
                    </span>
                    <span v-else>--</span>
                </template>
                <template slot="gldAmt" slot-scope="text">{{ text | splitK }}</template>
                <template slot="exDay" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
                <template slot="estbDay" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
                <template slot="canBeModified" slot-scope="text">{{ text | gbCbmTrans }}</template>
                <template slot="status" slot-scope="text">{{ text == 3 ? "已拒绝" : "已同意" }}</template>
                <!-- <template slot="reviewType" slot-scope="text">{{ text == 1 ? "多级" : "一般" }}</template> -->
                <!-- <template slot="roleLevel" slot-scope="text, record">{{ record.reviewType == 1 ? getRoleLevel(text) :
                    "" }}</template> -->
                <template slot="operation" slot-scope="text, record">
                    <a @click="toPageDetail(record)">详情</a>
                    <a v-if="status == '1' && tableSelect.selectArray.includes(record.id)"
                        @click="toTransferContractCheck(record)">《连带责任担保函》</a>
                </template>
            </a-table>
            <div :class="{ 'table-total': pagination.total > 0, 'table-total-none': pagination.total == 0 }">
                共有记录：
                <span class="text-color-blue">{{ pagination.total }} 条</span>祺信面额：
                <span class="text-color-orange">{{ totalPayable(tableData) | splitK }} 元</span>
            </div>
        </div>
        <a-modal width="400px" :title="modalTitle" :visible="modalShow" :maskClosable="false" :footer="null"
            @cancel="modalShow = false;">
            <guarantee-password-modal v-if="modalShow" :modalData="modalData" @ok="modalOk"
                @cancel="modalCancel"></guarantee-password-modal>
        </a-modal>
        <a-modal :bodyStyle="{ height: '540px', overflow: 'auto' }" width="80%" title="连带责任担保函"
            :visible="showTransferContract" :footer="null"
            @cancel="showTransferContract = false; transferContractHtml = ''">
            <div v-html="transferContractHtml"></div>
        </a-modal>

    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import { selectTenant } from "@/api/login.js"
import { guaranteePage, findGuaranteeReviewRcptyOrManager, queryGoldguaranteeContract ,goldGuaranteePageExport} from "@/api/review.js"
import guaranteePasswordModal from "@/pages/review/guarantee/guarantee-password-modal"
export default {
    props: {
        tabType: {
            type: [String],
            required: false,
            default: function () {
                return ""; //所属tab的分类
            }
        },
        status: {
            type: [String],
            required: false,
            default: function () {
                return "";
            }
        },
    },
    name: "guarantee-main",
    components: {
        guaranteePasswordModal
    },
    data() {
        return {
            showTransferContract: false,
            transferContractHtml: "",
            isPromiseGoldcheck: false,
            searchData: {
                estbDay: [],
                gldId: "",
                receiver: {},
                exDay: [],
                canBeModified: [],
                manager: {},
                status: [],
                estb: {}
            },
            formConfig: [
                {
                    prop: "estbDay",
                    type: "dateRange",
                    label: "申请日期",
                },
                {
                    prop: "gldId",
                    type: "input",
                    label: "祺信编号",
                },
                {
                    prop: "estb",
                    type: "selectSearch",
                    label: "开立方",
                    option: [],
                    searchSource: true,
                    headNameFirst: "开立方名称",
                    headNameSecond: "社会信用代码",
                    valuePorp: "orgCode",
                    valuePorpReal: "cstId",
                    labelPorp: "cstNm",
                    searchHandle: "handleSearchKlf",
                },
                {
                    prop: "receiver",
                    type: "selectSearch",
                    label: "接收方",
                    option: [],
                    searchSource: true,
                    headNameFirst: "接收方名称",
                    headNameSecond: "社会信用代码",
                    valuePorp: "orgCode",
                    valuePorpReal: "cstId",
                    labelPorp: "cstNm",
                    searchHandle: "handleSearchJsf",
                },
                {
                    prop: "exDay",
                    type: "dateRange",
                    label: "到期日期",
                },
                {
                    prop: "manager",
                    type: "selectSearch",
                    label: "经办员",
                    option: [],
                    searchSource: true,
                    valuePorp: "managerIdCardNum",
                    valuePorpReal: "manager",
                    labelPorp: "managerName",
                    headNameFirst: "经办人名称",
                    headNameSecond: "身份证号",
                    searchHandle: "handleSearchManager"
                },
                {
                    prop: "canBeModified",
                    type: "select",
                    label: "变更状态",
                    mode: 'multiple',
                    option: this.dict.modifiedStatus,
                    defaultProps: {
                        value: "value",
                        label: "name"
                    }
                },
                {
                    prop: "status",
                    type: "select",
                    label: "状态",
                    hide: this.tabType == 'review',
                    mode: 'multiple',
                    option: [
                        { name: "已同意", value: "2" },
                        { name: "已拒绝", value: "3" }
                    ],
                    defaultProps: {
                        value: "value",
                        label: "name"
                    }
                }
            ],
            columns: [
                {
                    title: "申请日期",
                    sorter: true,
                    dataIndex: "estbDay",
                    scopedSlots: { customRender: "estbDay" },
                    width: 120
                },
                {
                    title: "祺信编号",
                    dataIndex: "gldId",
                    sorter: true,
                },
                {
                    title: "开立方",
                    dataIndex: "estbNm",
                    sorter: true
                },
                {
                    title: "担保方",
                    dataIndex: "guaranteeName",
                    scopedSlots: { customRender: "guaranteeName" },
                },
                {
                    title: "接收方",
                    dataIndex: "rcPtyNm",
                    sorter: true
                },
                {
                    title: "祺信面额(元)",
                    dataIndex: "gldAmt",
                    sorter: true,
                    scopedSlots: { customRender: "gldAmt" },
                    width: 120
                },
                {
                    title: "到期日期",
                    sorter: true,
                    dataIndex: "exDay",
                    scopedSlots: { customRender: "exDay" },
                    width: 120
                },
                {
                    title: "变更状态",
                    dataIndex: "canBeModified",
                    scopedSlots: { customRender: "canBeModified" },
                },
                // {
                //     title: "复核类型",
                //     dataIndex: "reviewType",
                //     scopedSlots: { customRender: "reviewType" },
                // },
                // {
                //     title: "复核级别",
                //     dataIndex: "roleLevel",
                //     scopedSlots: { customRender: "roleLevel" },
                // },
                {
                    title: "经办员",
                    dataIndex: "managerName"
                },
                {
                    title: "状态",
                    dataIndex: "status",
                    hide: this.tabType == 'review',
                    scopedSlots: { customRender: "status" }
                },
                {
                    title: "操作",
                    dataIndex: "operation",
                    scopedSlots: { customRender: "operation" },
                }
            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "",
                sortOrder: "",
                total: 0,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['5', '10', '20', '50', '100'],
                showTotal: (total) => {
                    return `共 ${total} 条`
                }
            },
            loading: false,
            selectedRows: [],
            selectedRowKeys: [],
            selectArray: [],
            checkLoad: false,
            checkLoadCancel: false,
            modalShow: false,
            modalData: {},
            modalTitle: "同意",
            tableDataAllPage: []

        };
    },
    computed: {
        ...mapGetters({
            userObj: "home/getUserObj"
        }),
        tableSelect() {
            if (this.tabType == 'review') {
                return {
                    selectedRowKeys: this.selectedRowKeys,
                    selectedRows: this.selectedRows,
                    selectArray: this.selectArray,
                    onChange: this.onTableChange,
                }
            }
        },
    },
    methods: {
          onExport() {
         const params = {
                // orderBy: sortMap[this.pagination.sortField]
                // ? `${sortMap[this.pagination.sortField]} ${
                //     this.pagination.sortOrder == "ascend" ? "asc" : "desc"
                // }`
                // : "",
                orderBy: this.pagination.sortField
                    ? `${this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
                    }`
                    : "",
                status: (this.searchData.status && this.searchData.status.length > 0) ? this.searchData.status.join(',') : this.status,
                
                manager: this.searchData.manager.key,
                estb: this.searchData.estb.key,
                gldId: this.searchData.gldId,
                rcPty: this.searchData.receiver.key,
                canBeModified: (this.searchData.canBeModified && this.searchData.canBeModified.length > 0) ? this.searchData.canBeModified.join(',') : null,
                estbDayStart: this.searchData.estbDay[0],
                estbDayEnd: this.searchData.estbDay[1],
                exDayStart: this.searchData.exDay[0],
                exDayEnd: this.searchData.exDay[1],
            };
      goldGuaranteePageExport(params).then(res => {
        this.utils.fileDownload(res, `查询记录_${new Date().getTime()}.xls`);
      }).catch(e => {
        this.$message.error("导出失败");
      })
    },
        toTransferContractCheck(record) {
            let params = {
                gldId: record.gldId,
                rcPtyNm: record.rcPtyNm,
                estbNm: record.estbNm,
                estbDay: record.estbDay,
                exDay: record.exDay,
                rcPty: record.rcPty,
                guaranteeName: record.guaranteeName,
                gldAmt: record.gldAmt,
            }

            queryGoldguaranteeContract({ ...params }, true)
                .then((res) => {
                    this.transferContractHtml = res.data.contractContent;
                    this.showTransferContract = true;
                })
                .catch((err) => {
                    console.log(err);
                })
        },
        handleSearchJsf(value, data, cfg) {
            const cstIds = this.userObj.cstIds.join(",");
            let param = {
                queryType: 0
            };
            this.getDataList(value, param, cfg);
        },
        handleSearchKlf(value, data, cfg) {
            const cstIds = this.userObj.cstIds.join(",");
            let param = {
                queryType: 0
            };
            this.getDataList(value, param, cfg);
        },
        getDataList(value, param = {}, cfg) { //下拉筛选
            const cstIds = this.userObj.cstIds.join(",");
            findGuaranteeReviewRcptyOrManager({
                cstNm: value,
                pageNum: 1,
                pageSize: 10,
                status: 0,
                queryType: param.queryType
            }).then((res) => {
                const index = this.formConfig.findIndex(item => item.prop == cfg.prop);
                if (res.data && res.data.grid) {
                    this.formConfig[index].option = res.data.grid.list || [];
                } else {
                    this.formConfig[index].option = []
                }
            })
                .catch((error) => {
                    console.log(error);
                });
        },
        handleSearchManager(value, data, cfg) {
            findGuaranteeReviewRcptyOrManager({
                pageNum: 1,
                pageSize: 10,
                status: 0,
                queryType: 1,
                managerName: value
            }).then((res) => {
                const index = this.formConfig.findIndex(item => item.prop == cfg.prop);
                if (res.data && res.data.grid) {
                    this.formConfig[index].option = res.data.grid.list || [];
                } else {
                    this.formConfig[index].option = []
                }
            })
                .catch((error) => {
                    console.log(error);
                });
        },
        search(data) {
            this.searchData = data || this.searchData;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            const today = this.utils.dateFormat(new Date(), "yyyy-MM-dd");
            // const sortMap = {
            //     estbDay:"GLD.ESTB_DAY",
            //     gldAmt:"GLD.GLD_AMT",
            //     exDay:"GLD.EX_DAY"
            // }
            const params = {
                // orderBy: sortMap[this.pagination.sortField]
                // ? `${sortMap[this.pagination.sortField]} ${
                //     this.pagination.sortOrder == "ascend" ? "asc" : "desc"
                // }`
                // : "",
                orderBy: this.pagination.sortField
                    ? `${this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
                    }`
                    : "",
                status: (this.searchData.status && this.searchData.status.length > 0) ? this.searchData.status.join(',') : this.status,
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize,
                manager: this.searchData.manager.key,
                estb: this.searchData.estb.key,
                gldId: this.searchData.gldId,
                rcPty: this.searchData.receiver.key,
                canBeModified: (this.searchData.canBeModified && this.searchData.canBeModified.length > 0) ? this.searchData.canBeModified.join(',') : null,
                estbDayStart: this.searchData.estbDay[0],
                estbDayEnd: this.searchData.estbDay[1],
                exDayStart: this.searchData.exDay[0],
                exDayEnd: this.searchData.exDay[1],
            };
            guaranteePage(params)
                .then((res) => {
                    this.loading = false;
                    this.pagination.total = res.data.grid.total;
                    this.tableData = res.data.grid.list;
                    this.renderTableAllPage();
                })
                .catch(err => {
                    this.loading = false;
                    console.log(err);
                })
        },
        totalPayable(list = [], prop = "gldAmt") {
            return list.reduce((acc, rec) => {
                return acc + (+rec[prop] || 0);
            }, 0);
        },
        handleTableChange(pagination, filters, sorter) { //表格排序回调
            this.pagination = {
                current: pagination.current,
                pageSize: pagination.pageSize,
                sortField: sorter.field,
                sortOrder: sorter.order,
                total: this.pagination.total || 0,
            };
            this.getTableData();
        },
        onTableChange(selectedRows, data, data2) { //表格选择回调
            this.selectedRowKeys = selectedRows;
            this.selectedRows = this.tableDataAllPage.filter(item => selectedRows.indexOf(item.id + "_" + item.createTime) > -1);
            this.selectArray = data.map(item => item.id)
        },
        renderTableAllPage() { //记录加载的数据，用于记录选中的表格数据
            this.tableData.forEach(i => {
                let flag = this.tableDataAllPage.find(item => item.id == i.id && item.createTime == i.createTime);
                let idList = this.tableDataAllPage.map(i => i.id)
                if (!flag && idList.indexOf(i.id) == -1) {
                    this.tableDataAllPage.push(i);
                }
            })
        },
        handleChangeTag(tag, checked) {
            this.selectedTag = tag.value;
        },
        getCircleList(value) {
            this.selectTenant(value);
        },
        selectTenant(value) { //下拉筛选
            selectTenant({
                pageSize: 10,
                tenantName: value || "",
                pageNum: 1,
            }).then((res) => {
                this.recPersonList = res.data.grid.list;
            })
                .catch((error) => {
                    console.log(error);
                });
        },
        toPageDetail(data) {
            let way = "buyer";
            this.MENUAPI.goToOneTab({
                path: "bill-payment/payment/detail/" + way + "/" + data.gldId + "/3",
                query: {
                    isGluarantee: true //判断是否已融资
                }

            });
        },
        showModal(type) {
            if (!this.isPromiseGoldcheck && type == 2) {
                return this.$message.warning('请先勾选《连带责任担保函》')
            }
            this.modalData = {
                gldIds: this.selectedRows.map(i => i.gldId) || [],
                status: type,
                sumGoldAmt: this.totalPayable(this.selectedRows || [])
            };
            this.modalTitle = type == 3 ? "拒绝" : "同意";
            this.modalShow = true;
        },
        modalOk() {
            this.modalShow = false;
            this.refresh();
        },
        modalCancel() {
            this.modalShow = false;
            this.refresh();
        },
        getRoleLevel(text) {
            switch (+text) {
                case 0:
                    return "结束";
                default:
                    return text + "级";
            }
        },
        refresh() {
            this.tableDataAllPage = [];
            this.selectedRows = [];
            this.selectedRowKeys = [];
            this.getTableData();
            this.$store.dispatch("home/getMessageCount");
        }
    },
    created() {
        this.formConfig = this.formConfig.filter(i => !i.hide);
        this.columns = this.columns.filter(i => !i.hide);
        if (!this.pagination.sortField) {
            this.pagination.sortField = "estbDay";
            this.pagination.sortOrder = "descend";
        }
        this.getTableData();
    },
    mounted() { },
    activated() { },
};
</script>
<style scoped>
.input-content>div {
    margin: 10px 20px 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/review/guarantee/guarantee-main.vue